import { ComingSoon } from "./page-shell";

export const NotFoundPage = () => (
  <ComingSoon
    title="Page not found"
    description="That route does not exist in this build."
    hint="Use the sidebar to find what you were looking for."
  />
);
